var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectIsOfferPurchased } from "../../../selectors/selectPaymentEntryInfo";
import { TextLoca } from "../../generic/text/TextLoca";
import { OfferLevelReward } from "./OfferLevelReward";
export var _OfferPageGrowingReward = function (_a) {
    var offer = _a.offer, isOfferPurchased = _a.isOfferPurchased;
    if (offer == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var _b = React.useState(false), shakeButton = _b[0], setShakeButton = _b[1];
    var backgroundColor = offer.backgroundColor, locaKeyTitle = offer.locaKeyTitle;
    var tintStyle = {
        backgroundColor: backgroundColor,
        border: "none",
        height: "100%",
        width: "100%",
    };
    var buttonStyle = shakeButton ? { animation: "wiggle 1s ease -0.5s" } : undefined;
    return (React.createElement("div", { className: "offer-container" },
        React.createElement("div", { className: IdStyles.OfferHeader + " offer-header-container" },
            React.createElement(TextLoca, { id: locaKeyTitle, className: "" + IdStyles.HeadlineOne })),
        React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-body__container" },
            React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-container__tint", style: tintStyle }),
            React.createElement("div", { className: "offer-body__details" },
                React.createElement(OfferLevelReward, __assign({}, offer, { onTryCollect: function () {
                        return;
                    } })),
                !isOfferPurchased && (React.createElement("div", { className: "offer-body__buy-btn", style: buttonStyle, onAnimationEnd: function () { return setShakeButton(false); } }))))));
};
var mapState = function (state, ownProps) { return ({
    isOfferPurchased: selectIsOfferPurchased(state, ownProps.offer.offerCharacteristicId),
}); };
export var OfferPageGrowingReward = connect(mapState)(_OfferPageGrowingReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferPageGrowingReward.tsx
// module id = 2914
// module chunks = 3